/* src/app/_shared/components/signature-pad/signature-pad.modal.scss */
.buttons-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-evenly;
}
.buttons-container.mobile {
  position: absolute;
  top: 0;
  right: var(--space-bottom);
  transform: rotate(-90deg);
  transform-origin: bottom right;
}
.buttons-container app-button {
  flex-grow: 1;
}
.buttons-container app-button.clear-pad {
  margin-right: var(--space-right);
  --background-color: var(--ion-color-danger);
  --text-color: var(--ion-color-danger-contrast);
}
main {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
signature-pad {
  flex-grow: 1;
  display: block;
  overflow: hidden;
  padding: 20px !important;
}
ion-content {
  --overflow: hidden;
  --padding-top: var(--ion-safe-area-top);
  --padding-bottom: 0;
}
/*# sourceMappingURL=signature-pad.modal.css.map */
